import { FC } from 'react';
import { Logo } from '../assets/Logo';

export const AppHeader: FC = () => (
    <header className="app__header">
        <Logo />
    </header>
);

